export default "__VITE_ASSET__Cw3u1QQp__"